// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4318":"3505a6ea","4374":"3505a6ea","5216":"4b678cbc","6368":"1fbd8e10","6638":"a3907e55"}[chunkId] + ".chunk.css";
};